import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RegisterWebinarComponent } from '../register-webinar/register-webinar.component';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { AuthService } from 'src/app/services/auth.service';
import { timeZones } from 'src/app/models/time-zones-model';

@Component({
  selector: 'app-webinar-view',
  templateUrl: './webinar-view.component.html',
  styleUrls: ['./webinar-view.component.scss']
})
export class WebinarViewComponent implements OnInit {
  webinarId: any;
  register: any = 0;
  companies: any = [1,2,3,4,5,6,7,8,9,10];
  webinar: any;
  adminCreated: boolean = false;
  webinarDateTime: string = '';
  iswebinarActive: boolean = true;
  signin: any;
  isSponsored: boolean = false;
  selectedTabName : string = '';
  timezoneAbbreviation: any = '';
  isCME: boolean = false;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog, 
    private sweetAlertService: SweetAlertService, 
    private route: ActivatedRoute, 
    private webinarService: WebinarService,
    private authService: AuthService
   ){}

  ngOnInit(): void {
    const topOfPage = document.querySelector('app-website-header');
    if(topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
    this.localStorageService.getUserDetails().subscribe((userDetails) => {
      this.signin = userDetails;
    });
    this.route.params.subscribe((p: any)=>{
      this.webinarId = p.id
      this.getWebinar(this.webinarId);
      this.registered();
    })
    if(window.history.state && window.history.state.isSponsored) {
      this.isSponsored = window.history.state.isSponsored
    }
    setTimeout(() => {
      const showPopup = localStorage.getItem('showWebinarPopup');
      if (showPopup === 'true' && this.webinar?.webinarDate) {
        const webinarDateStr = this.getDate(this.webinar.webinarDate);
        let webinarTimeStr = '23:59:00';
        if (this.webinar.webinarTime && Array.isArray(this.webinar.webinarTime)) {
          webinarTimeStr = this.getTime(this.webinar.webinarTime);
        }

        const combinedDateTimeStr = `${webinarDateStr}T${webinarTimeStr}`;
        const webinarDateTime = new Date(combinedDateTimeStr);
        const now = new Date();

        if (now < webinarDateTime) {
          this.registerToWebinar();
        }
      }

      localStorage.removeItem('showWebinarPopup');
    }, 500);
  }
  timeToWebinar: any[] = [];
  formatwebinarDate: any;
  formatwebinarTime: any;

  timeLeft(webinarDate: string, webinarTime: any): void {
    const now = new Date();
    const webinarDateTime = new Date(`${webinarDate} ${webinarTime}`);
    const timeDifference = webinarDateTime.getTime() - now.getTime();

    if (timeDifference > 0) {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      const timeLeft = `${days} days ${hours} hours ${minutes} minutes and ${seconds} seconds`;
      this.timeToWebinar = [days, hours, minutes, seconds];
      setInterval(() => {
        this.timeLeft(this.formatwebinarDate, this.formatwebinarTime);
      }, 1000);
    } else {
    }
  }

  reformatDuration(duration: any): string {
    const hours = duration[0] < 10 ? '0' + duration[0] : duration[0];
    const minutes = duration[1] < 10 ? '0' + duration[1] : duration[1];
    let seconds = '00';
    if (duration.length > 2) {
      seconds = duration[2] < 10 ? '0' + duration[2] : duration[2];
    }
    return `${hours}:${minutes}:${seconds}`;
  }

  reformatTime(time: any): string {
    if(time === undefined || time === null || time === 'N/A') return '';
    let hours = time[0];
    const minutes = time[1] < 10 ? '0' + time[1] : time[1];
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes} ${ampm}`;
  }
  getDate(list: number[]) {
    return list.map(n => n.toString().padStart(2, '0')).join('-');
  }

  getTime(list: number[]) {
    return list.map(n => n != null ? n.toString().padStart(2, '0') : '00').join(':');
  }

  getTimezoneAbbreviation(timezone: string): string {
    if (!timezone) return '';
    if (timezone in timeZones) {
      return timeZones[timezone as keyof typeof timeZones];
    }
    return timezone;
  }

  getWebinar(id: string){
    this.webinarService.getWebinarById(id).subscribe((res: any)=>{
      this.webinar = res.data.webinar;
      if (this.webinar?.timezone) {
        this.timezoneAbbreviation = this.getTimezoneAbbreviation(this.webinar.timezone);
      }
      this.adminCreated = res.data.adminCreated;
      this.webinarDateTime = '';
      if(this.webinar?.webinarDate && this.webinar?.webinarTime){
        this.formatwebinarDate = this.webinar.webinarDate[0] + '/' + this.webinar.webinarDate[1] + '/' + this.webinar.webinarDate[2]
        this.formatwebinarTime = this.reformatTime(this.webinar.webinarTime)
        this.timeLeft(this.formatwebinarDate, this.formatwebinarTime);
        this.webinarDateTime += this.getDate(this.webinar?.webinarDate) + ' ' + this.getTime(this.webinar?.webinarTime);
      }
      if ((this.webinarDateTime && new Date(this.webinarDateTime) >= new Date() || this.webinarDateTime === 'N/A') || (this.webinarDateTime && new Date(this.webinarDateTime) >= new Date()) ) {
        this.iswebinarActive = false;
      }
      if(this.webinar?.webinarDate > new Date() || this.webinar?.webinarDate === null){
        this.iswebinarActive = false;
      }
    })
  }
  registerToWebinar(){
    if(!this.signin){
      this.authService.setLastVisitedUrl(this.router.url);
      localStorage.setItem('showWebinarPopup', 'true');
      Swal.fire({
                        iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
                        iconColor: '#ffffff',
                        title: '<strong>Log in to register webinar</strong>',
                        showCancelButton: true,
                        confirmButtonText: 'Login',
                        cancelButtonText: 'Cancel',
                        html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? <a href="/user/signup" style="color: blue;font-size: 16px;font-weight: 600; text-decoration: underline;text-wrap:nowrap">Join Now</a></p>`,
                        focusConfirm: false
                      }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigate(['/login']);
          }
        });
      return;
    }
    if(this.webinar.webinarSource === 'Other'){
      let url = this.webinar.webinarUrl;
      if(url === undefined || url === null || url === 'N/A') return;
      else if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www'))) return;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
      window.open( url,'_blank');
      return;
    }
    if(!this.isRegistered){
     // Check if webinar type is a CME
      const isCME = this.webinar?.type === 'cme' || false;
      
      const dialogRef = this.dialog.open(RegisterWebinarComponent, {
        width: '520px',
        panelClass: 'center-dialog',
        data: { 
          webinarId: this.webinarId,
          flag: isCME,  // Pass CME flag - true for CME, false for Webinar
          paid: this.webinar.paid,
          amount: this.webinar.amount
        }
      });
      
      dialogRef.afterClosed().subscribe((res: any) => {
        // Check if registration was successful
        if (res && res !== "isNotPayment") {
          this.registered();
        }
      });
    }
  }
  onViewRecording(){
    if(!this.signin){
      this.authService.setLastVisitedUrl(this.router.url);
      Swal.fire({
                        iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
                        iconColor: '#ffffff',
                        title: '<strong>Log in to register webinar</strong>',
                        showCancelButton: true,
                        confirmButtonText: 'Login',
                        cancelButtonText: 'Cancel',
                        html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? <a href="/user/signup" style="color: blue;font-size: 16px;font-weight: 600; text-decoration: underline;text-wrap:nowrap">Join Now</a></p>`,
                        focusConfirm: false
                      }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigate(['/login']);
          }
        });
      return;
    }
      let url = this.webinar.webinarRecordUrl;
      if(url === undefined || url === null || url === 'N/A') return;
      else if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www'))) return;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
      window.open( url,'_blank');
}
  navigate(): void {
    this.router.navigate(['./webinars'], {});
  }

  isRegistered: boolean = false;
  registered(): void {
    this.localStorageService.getUserDetails().subscribe((userDetails) => {
      this.signin = userDetails?.email;
    });
  
    this.webinarService.getWebinarById(this.webinarId).subscribe((res: any) => {
      console.log("Webinar details:", res);
      const registeredCustomers = res.data?.regiteredCustomers ?? [];
  
      // Determine if the user is registered
      const registeredCustomer = registeredCustomers.find(
        (c: any) => c.email === this.signin
      );
  
      // For free webinars
      if (registeredCustomer && !this.webinar?.paid) {
        this.isRegistered = true;
      }
  
      // For paid webinars
      if (this.webinar?.paid && registeredCustomer) {
        const isPaymentSuccessful = registeredCustomer.paymentStatus === 'CAPTURED';
        this.isRegistered = isPaymentSuccessful;
      }
    });
  }
}